import axios from "@util/axios"

class Companies {
    async getCompanies(params = {}) {
        return await axios({
            url: `/company/`,
            params: params,
        })
    }

    async createCompany(formData) {
        return await axios({
            url: `/company/`,
            method: "POST",
            data: {
                role_id: formData.role_id || null,
                role_value: formData.role_value || null,
                name: formData.name || null,
                status: formData.status || null,
                email_domain: formData.email_domain || null,
                default_report_id: formData.default_report_id || null,
                fcp_role: formData.fcp_role || null,
                address: formData.address || null,
                filevine_id: formData.filevine_id || null,
            },
        })
    }

    async readCompany(id) {
        return await axios({
            url: `/company/${id}/`,
        })
    }

    async updateCompany(id, formData) {
        return await axios({
            url: `/company/${id}/`,
            method: "PUT",
            data: {
                role_id: formData.role_id || null,
                role_value: formData.role_value || null,
                name: formData.name || null,
                status: formData.status || null,
                email_domain: formData.email_domain || null,
                default_report_id: formData.default_report_id || null,
                fcp_role: formData.fcp_role || null,
                address: formData.address || null,
                filevine_id: formData.filevine_id || null,
            },
        })
    }

    async deleteCompany(id) {
        return await axios({
            url: `/company/${id}`,
            method: "DELETE",
        })
    }

    async deleteCompanyLogo(id) {
        return await axios({
            url: `/company/logo/${id}/`,
            method: "DELETE",
        })
    }
}

export default new Companies()
